import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/iconfont.css'
import '@/assets/font_exam/iconfont.css'
import '@/assets/font_3832052_7t16x1n5if3/iconfont.css'
import axios from 'axios'
import $config from './config'
import $util from './util/requestUtil'
import VueClipboard from 'vue-clipboard2'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import api from '@/util/api'
import Print from '@/assets/vue-print-nb'
import '@/directives/resize.js' // 自定义指令监听元素大小变化
import qs from 'qs'
import '@/assets/app_css/index.css';
import '@/assets/design-page/imitationForm.css';
// import 'babel-polyfill'

Vue.component('chart', ECharts)
// import echarts from 'echarts'
import echarts from 'echarts'
import * as qiniu from 'qiniu-js'
// 
// import dataV from '@jiaminghi/data-view'
// 高德地图
import AMap from 'vue-amap'
// 引入vuex
import store from './store/index.js'
// 引入icon
import '@/assets/fonts/iconfont.css'
import '@/assets/contacts/iconfont.css'
import '@/assets/chartIcon/iconfont.css'
import '@/assets/menu_icon/iconfont.css'
import '@/assets/font_wjpc/iconfont.css'
import tinymce from 'tinymce'
import VueTinymce from '@packy-tang/vue-tinymce'
import 'tinymce/icons/default/icons'
import draggable from 'vuedraggable'

import functions from '@/util/functions';
// 导入全局样式表 Lh
import './assets/css/indexT.css'
import filters from "./components/filters"//用于处理浮点数小数位数
//全局方法Vue.filter()统一注册自定义过滤器

Object.keys(filters).forEach(key => {//返回filters对象中属性名组成的数组
  Vue.filter(key, filters[key])
})

Vue.component('draggable', draggable)

// 

// import VueAMap from 'vue-amap';
 
// Vue.use(VueAMap);
 
// VueAMap.initAMapApiLoader({
 
//   key: 'dce479808dfc950476a2fe10cde5f297',
 
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
 
//   // 默认高德 sdk 版本为 1.4.4
 
//   v: '1.4.4'
 
// })
Vue.prototype.$defaultLang = 'zh-CN'
let language = window.localStorage.getItem('lang') || Vue.prototype.$defaultLang;
if (!window.localStorage.getItem('lang')) {
	window.localStorage.setItem('lang', language)
}
Vue.prototype.$tinymce = tinymce
Vue.use(VueTinymce)
Vue.prototype.$echarts = echarts
Vue.prototype.$config = $config;
Vue.prototype.$axios =axios;
Vue.prototype.$util = $util;
Vue.prototype.$functions = functions;
Vue.config.productionTip = false;
Vue.prototype.$qs = qs
Vue.prototype.$language = language
if (functions.isFoTon()) {
	Vue.prototype.$logo = require('@/assets/foton/foton40black.png')
} else {
	Vue.prototype.$logo = require('@/assets/aixue.png')
}
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI);
Vue.use(VueClipboard)
// Vue.use(dataV)
Vue.use(qiniu)
Vue.use(AMap)
Vue.use(Print)

Vue.prototype.$api = api;

AMap.initAMapApiLoader({
    key:'2de8f26b655c1e999adf68de76843f0a', //高德申请的key
    plugin: [ //扩展插件
		'AMap.Autocomplete', //输入提示
		'AMap.PlaceSearch', //POI搜索
		'AMap.Scale', //比例尺
		'AMap.OverView',  //地图鹰眼插件
		'AMap.ToolBar',  //地图工具条
		'AMap.MapType', //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
		'AMap.PolyEditor', // 编辑 折线多，边形
		'AMap.CircleEditor', // 圆形编辑器插件
		'AMap.Geolocation', // 定位控件，用来获取和展示用户主机所在的经纬度位置
		'AMap.CitySearch',
	],
    v: '1.4.4'
})
import VueAreaLinkage from 'vue-area-linkage';
import 'vue-area-linkage/dist/index.css'; 
Vue.use(VueAreaLinkage);


// 引入element-tiptap
import { ElementTiptapPlugin } from 'element-tiptap';
// import element-tiptap 样式
import 'element-tiptap/lib/index.css';
//使用
Vue.use(ElementTiptapPlugin,{
//   lang: 'zh',
  lang: functions.language(language),
});
import i18n from '@/i18n'
var vue = new Vue({
    router,
    $config,
    $util,
    store,
	i18n,
    render: h => h(App),
}).$mount('#app')
export default vue
